import { Maybe } from '@Types'

// An overclaim is "closed" once it has been resolved, merged into another work, or cancelled.
// Closed overclaims no longer surface member documentation status or due dates.
export const CLOSED_OVERCLAIM_STATUSES = ['RESOLVED', 'MERGED', 'CANCELED']

export const isOverclaimClosed = (status?: Maybe<string>): boolean =>
    !!status && CLOSED_OVERCLAIM_STATUSES.includes(status)
